import { DateTime } from '@ksyos/date-time';
import { FormSection } from '@ksyos/design-system';
import type { OsasTrialPeriod } from '@common/enums/osasTrialPeriod';
import type {
    OsasEvaluationData,
    TreatmentChoice,
} from '@common/validation/customControls/osas/osasEvaluationSchemas/types';
import { useProcessActivityEditContext } from '@frontend/utils';
import {
    BooleanRadioGroupFormGroup,
    DateInputFormGroup,
    TextAreaFormGroup,
} from '../../../processActivityFormGroupFields';
import { TrialPeriodFormSection } from './TrialPeriodFormSection';

type AnamnesisFormSectionProps = {
    onChangeTrialPeriod: (treatmentsToChange: TreatmentChoice, trialPeriod: OsasTrialPeriod) => void;
};

export function AnamnesisFormSection(props: Readonly<AnamnesisFormSectionProps>) {
    const { onChangeTrialPeriod } = props;
    const { errors, data, onChange } = useProcessActivityEditContext<OsasEvaluationData>();

    return (
        <FormSection title="Anamnese">
            <BooleanRadioGroupFormGroup
                fieldKey="hadContactWithPatient"
                label="Contact met patiënt gehad?"
                onChange={async (checked) =>
                    onChange(
                        {
                            hadContactWithPatient: checked,
                        },
                        'hadContactWithPatient'
                    )
                }
                type="radio"
            />
            <TextAreaFormGroup
                fieldKey="medicalHistory"
                label="Anamnese"
            />
            <TrialPeriodFormSection onChangeTrialPeriod={onChangeTrialPeriod} />

            <DateInputFormGroup
                error={getDateError()}
                fieldKey="therapyStartDate"
                label="Therapie gestart op"
                maxDate={DateTime.now().format()}
            />
            <TextAreaFormGroup
                fieldKey="remark"
                label="Toelichting"
            />
        </FormSection>
    );

    function getDateError() {
        if (errors.has('therapyStartDate')) {
            if (!data.therapyStartDate) {
                return 'any_required';
            }

            return errors.get('therapyStartDate');
        }
    }
}
